/*
popoverRow.tsx
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import ScrollableDropdown, { DropdownOption } from './scrollableDropdown'
import DropdownSettingRow from '../routes/Scan/ScanSettingRows/dropdownSettingRow'

export interface PopoverRowProps {
  title: string
  value?: DropdownOption
  options: DropdownOption[]
  defaultOption: DropdownOption
  onSelect: (option: DropdownOption) => void
  iconPath?: string
  iconStyles?: string
  glyphName?: string
  id?: string
}

export default function PopoverRow({
  title,
  value,
  options,
  defaultOption,
  onSelect,
  iconPath,
  iconStyles,
  glyphName,
  id = 'popover-row'
}: PopoverRowProps) {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState<boolean>(false)

  // const handleClick = () => {
  //   setIsOpen(!isOpen)
  // }

  return (
    <li
      className='list-group-item divider list-group-item-action'
      tabIndex={0}
    >
      <DropdownSettingRow isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className='left-object custom-icon-rounded'>
        {iconPath && (
          <img
            src={iconPath}
            className={`img-fluid ml-0 ${iconStyles}`}
            alt={title}
          />
        )}
        {glyphName && (
          <i className={`${glyphName} xglsize-32`}></i>
        )}
      </div>
      <div className='content-container'>
        <div className='left-label pl-4'>
          <span>{t(title)}</span>
        </div>
        <div className='right-object'>
          <ScrollableDropdown
            title={title}
            id={id}
            options={options}
            selectedOption={value}
            defaultOption={defaultOption}
            onSelect={onSelect}
            isOpen={isOpen}
            onToggle={setIsOpen}
          />
        </div>
      </div>
      </DropdownSettingRow>
    </li>
  )
}
